import React, { FC, ReactNode } from "react"
import { MasterLayout } from "../views/atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../views/atoms/layouts/BodyWithRightSidebarLayout"
import { Spacer } from "../views/atoms/Atoms"
import { CarrotExpertsModule } from "../views/molecules/CarrotExpertsModule"
import DefaultMarkdown from "../views/DefaultMarkdown"
import { SideBarBase } from "components/views/atoms/SidebarBase"
import { TalkToCarrotChatHeader } from "./TalkToCarrotChatHeader"
import { H2Library } from "@carrotfertility/carotene"

type TalkToCarrotLayoutProps = {
  subtitle: string
  description: string
  children: ReactNode
  sidebar?: ReactNode
}

const TalkToCarrotLayout: FC<TalkToCarrotLayoutProps> = ({
  subtitle,
  description,
  children,
  sidebar = <ChatSideBar />
}: TalkToCarrotLayoutProps) => (
  <MasterLayout header={<TalkToCarrotChatHeader />}>
    <BodyWithRightSidebarLayout sidebar={sidebar}>
      <H2Library>{subtitle}</H2Library>
      <Spacer height={0.5} />
      <DefaultMarkdown source={description} />
      <Spacer height={3} />
      {children}
    </BodyWithRightSidebarLayout>
  </MasterLayout>
)

const ChatSideBar: FC = () => (
  <SideBarBase>
    <CarrotExpertsModule />
  </SideBarBase>
)

export { TalkToCarrotLayout }
